import React from 'react';
import { motion } from 'framer-motion';
import RAC_CONFIG from '../../config/racConfig';
import './RACEarningsTable.css';

const RACEarningsTable = () => {
  console.log('[RACEarningsTable] Component rendered');
  
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount);
  };
  
  return (
    <section className="rac-earnings-table">
      <div className="rac-earnings-table-container">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rac-section-title"
        >
          Earnings Structure
        </motion.h2>
        <div className="rac-gold-line"></div>
        
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="rac-table-wrapper"
        >
          <table className="rac-earnings-table-content">
            <thead>
              <tr>
                <th>Tier</th>
                <th>Animals</th>
                <th>Scheduled Monthly Hire Rent (full-service month)</th>
                <th>Indicative annualized rate</th>
                <th>Tenure</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="rac-amount">{formatCurrency(250000)}</td>
                <td>1</td>
                <td className="rac-income-gold">{formatCurrency(3750)} / month</td>
                <td>Up to 18% p.a.</td>
                <td>60 payable months target</td>
              </tr>
              <tr>
                <td className="rac-amount">{formatCurrency(500000)}</td>
                <td>2</td>
                <td className="rac-income-gold">{formatCurrency(7500)} / month</td>
                <td>Up to 18% p.a.</td>
                <td>60 payable months target</td>
              </tr>
              <tr>
                <td className="rac-amount">{formatCurrency(1000000)}</td>
                <td>4</td>
                <td className="rac-income-gold">{formatCurrency(15000)} / month</td>
                <td>Up to 18% p.a.</td>
                <td>60 payable months target</td>
              </tr>
            </tbody>
          </table>
          
          <div className="rac-table-tenure-note">
            <p><strong>Tenure note:</strong> The program is structured to deliver 60 payable months (equivalent) per animal. Expected calendar duration is ~70 months (5 years 10 months) plus per-animal extensions for suspension days.</p>
          </div>
          
          <div className="rac-table-footnote">
            <p><strong>Footnote:</strong> Scheduled monthly hire rent assumes a full-service month. Actual monthly hire rent payout is prorated by Active Lease Days. Planned dry days are non-payable up to the 60-day Contract Year cap. Dry days beyond the 60-day Contract Year cap are treated as suspension days and trigger per-animal extension as defined in the hire-back agreement. Hire rent may pause during death, vet-certified unfit/non-performing, or replacement processing (including onboarding). Replacement timing: within 30 working days (excluding Saturdays, Sundays, and declared government holidays) from the date of death or the date of vet certification of unfit/non-performing (whichever applies). Hire rent depends on the hire-back agreement terms and PharmWealth's performance as counterparty (counterparty risk). Hire rent resumes once the replacement is onboarded.</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default RACEarningsTable;


